import { POST } from '@wellsfargo/ecpfs-authority'

export const PRE_REGISTERED_DETAILS_PATH =
	'register/getPreRegisteredDetails.json'

export function fetchPreRegisteredDetails() {
	return POST(PRE_REGISTERED_DETAILS_PATH, {})
}
